export default __webpack_public_path__ + "static/media/sustentacion_2.b9d9550a.jpg";